import { computeVariant } from '@/shared/lib/abTest';

import type { TrialVariant } from './types';

import { TRIAL_VARIANT_KEY } from './constants';

export const computeTrialVariant = (userId: string, country: null | string | undefined): TrialVariant =>
  computeVariant(TRIAL_VARIANT_KEY, userId, country) === 'A' ? 'C' : 'D';
